// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.support-banner[data-v-ff41d4c8] {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 16px;
  background: #b42318;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
.support-banner__text[data-v-ff41d4c8] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.support-banner__end[data-v-ff41d4c8] {
  flex: none;
  border: 1px solid #fff;
  border-radius: 4px;
  background: transparent;
  color: #fff;
  padding: 2px 12px;
  cursor: pointer;
}
.support-banner__end[data-v-ff41d4c8]:disabled {
  opacity: 0.6;
  cursor: default;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
